import { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

/**
 * Passwort-Eingabefeld mit Auge-Icon zum Anzeigen/Verbergen.
 * - Standard: type="password"
 * - Klick auf Auge: type="text"
 * - Keine Logging-Logik. Bestehende Sicherheit unverändert.
 */
const PasswordInput = forwardRef(({ className = "", testId, ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={visible ? "text" : "password"}
        autoComplete="current-password"
        className={`pr-10 ${className}`}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-500 hover:text-[#4A331D] focus:outline-none focus:ring-2 focus:ring-[#D4AA6A] rounded"
        data-testid={testId ? `${testId}-toggle` : "password-toggle"}
        tabIndex={-1}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
});
PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
